/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterMitInfosDto } from '../../models/mitarbeiter-mit-infos-dto';

export interface GetSingleMitarbeiterInfos$Json$Params {

/**
 * Id des Mitarbeiters von dem die MitarbeiterInfos geladen werden sollen
 */
  mitarbeiterId: string;
}

export function getSingleMitarbeiterInfos$Json(http: HttpClient, rootUrl: string, params: GetSingleMitarbeiterInfos$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterMitInfosDto>> {
  const rb = new RequestBuilder(rootUrl, getSingleMitarbeiterInfos$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterMitInfosDto>;
    })
  );
}

getSingleMitarbeiterInfos$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/infos';
